export default "/images/phoneBlack.svg?e0c18bf72647b134335b5aad48d50cb4";